<template>
    <div class="kitchenWap">
        <div class="livingRoomSpace">
            <div class="jianbianq"  :class="{'jianbianh':issjmx}" ref="sjmx">
            <div class="founder spaceCustomization">
                <div class="yishu marginTX"></div>
                <div class="beijing">卧室空间</div>
                <p v-html="seriesIntroduce.bedroomSpace"  class="kjjianjie" ></p>            
                <!-- <div class="moreBut">了解更多</div> -->
            </div>
            </div>
            
            <!-- 调整顺序：轻法式主套放到第一个 -->
            <div class="jianbianq"  :class="{'jianbianh':isLightFrenchMx}" ref="lightFrenchMx">
                <div class="spaceCustomization_img homeDecoration lightFrench" ref="lightFrench" @mouseenter="lightFrenchEnter" @mouseleave="lightFrenchLeave">
                    <img :src="'https://www.vifa.cn' + lightFrenchImage" alt="" v-if="lightFrenchImage">
                    <img src="@/common/image/bedroom1.png" alt="" v-else>
                    <div class="dingwei" :class="{'dingweishow':isLightFrenchDingwei}">
                        <div class="dingweia" @click="lightFrenchDingweia">+</div>
                        <div class="dingweic" @click="lightFrenchDingweic">+</div>
                    </div>
                    <div class="dwzhankai" v-show="isLightFrenchDwzhankai == index" v-for="(item,index) in lightFrenchData" :key='index' @click="lightFrenchDwguanbi">
                        <ul>
                            <li>
                                <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                                <div>{{item.title}}</div>
                                <p>{{item.introduce}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="hscttitle">轻法式主套</div>
                <router-link :to="{path:'/productDtails',query:{title:'轻法式主套',SpaceActiv:1}}"><div class="moreBut">了解更多</div></router-link>
            </div>

            <div class="jianbianq"  :class="{'jianbianh':isbrandConcepttitle}" ref="brandConcepttitle">
            <div class="spaceCustomization_img homeDecoration hsct" ref="homeDecoration" @mouseenter="homeDM" @mouseleave="homeDMout">
                <img src="@/common/image/bedroom1.png" alt="">
                <div class="dingwei" :class="{'dingweishow':isdingwei}">
                    <div class="dingweia" @click="hsctdingweia">+</div>
                    <div class="dingweib" @click="hsctdingweib">+</div>
                    <div class="dingweic" @click="hsctdingweic">+</div>
                    <div class="dingweid" @click="hsctdingweid">+</div>
                </div>
                <div class="dwzhankai" v-show="isdwzhankai == index" v-for="(item,index) in dwzhankaiData" :key='index' @click="dwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">珍珠杏卧室柜</div>
            <router-link :to="{path:'/productDtails',query:{title:'珍珠杏卧室柜',SpaceActiv:1,ittitle:'Armadio della camera da letto in albicocca perla',entitle:'Pearl apricot bedroom cabinet'}}"><div class="moreBut">了解更多</div></router-link>
            </div>


            <div class="jianbianq"  :class="{'jianbianh':isbrandConcepttitlee}" ref="brandConcepttitlee">
                <div class="spaceCustomization_img homeDecoration hsctt" ref="homeDecoration" @mouseenter="homeDMM" @mouseleave="homeDMoutt">
                    <img :src="'https://www.vifa.cn' + bedroom2image" alt="" />
                    <div class="dingwei" :class="{'dingweishow':isdingweii}">
                        <div class="dingweia" @click="hsctdingweiaa">+</div>
                        <div class="dingweib" @click="hsctdingweibb">+</div>
                        <div class="dingweic" @click="hsctdingweicc">+</div>


                    </div>
                    <div class="dwzhankai" v-show="isdwzhankaii == index" v-for="(item,index) in dwzhankaiDataa" :key='index' @click="dwguanbii">
                        <ul>
                            <li>
                                <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                                <div>{{item.title}}</div>
                                <p>{{item.introduce}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="hscttitle">爱丽丝卧室空间</div>
                <router-link :to="{path:'/productDtails',query:{title:'爱丽丝卧室空间',SpaceActiv:1,ittitle:'Armadio della camera da letto in albicocca perla',entitle:'Pearl apricot bedroom cabinet'}}"><div class="moreBut">了解更多</div></router-link>
            </div>

        </div>
            
    </div>
</template>

<script>
import { getProductDetails } from "@/api/api";


export default {
  name: 'bedroomSpace',
  data(){
      return{
        dwzhankaiData:[],
        dwzhankaiDataa:[],
        isdwzhankai:999,
        isdwzhankaii:999,
        isdingwei:false,
        isdingweii:false,
        // 新增第3个产品区域（轻法式主套）
        lightFrenchData:[],
        isLightFrenchDwzhankai:999,
        isLightFrenchDingwei:false,
        lightFrenchImage:null,
        isbrandConcepttitle:false,
        isbrandConcepttitlee:false,
        issjmx:false,
        issjmxx:false,
        bedroom2image:null,
        isLightFrenchMx:false,
      }
  },
    components: {
    },
    props:{
        seriesIntroduce: {
        type: String 
        }
    },
    mounted() {
       window.addEventListener("scroll", this.handleScroll);    
       this.isbrandConcepttitle = true    
       this.issjmx = true
        this.getkalajinyanData()
        this.getkalajinyanDataa()
        this.getLightFrenchData()
    },
    methods:{
        getkalajinyanData(){
            let data = {
                productName:"珍珠杏卧室柜"
            }
            getProductDetails(data)
            .then(res =>{
                this.dwzhankaiData = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getkalajinyanDataa(){
            let data = {
                productName:"爱丽丝卧室空间"
            }
            getProductDetails(data)
            .then(res =>{
                this.dwzhankaiDataa = res.productSpecific
                this.bedroom2image=res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getLightFrenchData(){
            let data = {
                productName:"轻法式主套"
            }
            getProductDetails(data)
            .then(res =>{
                this.lightFrenchData = res.productSpecific
                this.lightFrenchImage = res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        handleScroll(){
          this.$nextTick(()=>{
            this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.brandConcepttitlee.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitlee = false
                }

                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = false
                }
                if (this.$refs.brandConcepttitle.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = true
                }
                if (this.$refs.brandConcepttitlee.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitlee = true
                }
                if (this.$refs.sjmx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = true
                }
                if (this.$refs.lightFrenchMx && this.$refs.lightFrenchMx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isLightFrenchMx = true
                }

                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.brandConcepttitlee.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isbrandConcepttitlee = false
                }

                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.issjmx = false
                }
                if (this.$refs.lightFrenchMx && this.$refs.lightFrenchMx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isLightFrenchMx = false
                }
          })
            // }
        },
        homeDM(){
            this.isdingwei = true
        },
        homeDMout(){
            this.isdingwei = false
        },
        homeDMM(){
            this.isdingweii = true
        },
        homeDMoutt(){
            this.isdingweii = false
        },
        dwguanbi(){
            this.isdwzhankai = 999
        },
        dwguanbii(){
            this.isdwzhankaii = 999
        },
        hsctdingweia(){
            this.isdwzhankai = 0
        },
        hsctdingweib(){
            this.isdwzhankai = 1
        },
        hsctdingweic(){
            this.isdwzhankai = 2
        },
        hsctdingweid(){
            this.isdwzhankai = 3
        },

        hsctdingweiaa(){
            this.isdwzhankaii = 0
        },
        hsctdingweibb(){
            this.isdwzhankaii = 1
        },
        hsctdingweicc(){
            this.isdwzhankaii = 2
        },
      hsctdingweidd(){
        this.isdwzhankaii = 3
      },
      hsctdingweiee(){
        this.isdwzhankaii = 4
      },
      // 轻法式主套的方法
      lightFrenchEnter(){
          this.isLightFrenchDingwei = true
      },
      lightFrenchLeave(){
          this.isLightFrenchDingwei = false
      },
      lightFrenchDwguanbi(){
          this.isLightFrenchDwzhankai = 999
      },
      lightFrenchDingweia(){
          this.isLightFrenchDwzhankai = 0
      },
      lightFrenchDingweic(){
          this.isLightFrenchDwzhankai = 1
      },
  },
  unmounted(){
    window.removeEventListener("scroll", this.handleScroll);  
  }  
  }
</script>

<style scoped>
.kitchenWap .spaceCustomization p{
    /* width: 740px; */
    margin: 0 auto;white-space: pre-wrap;
    /* text-align: left; */
}
.hsct .dingwei .dingweia{
    left: 36%;
    top: 47.5%;
}
.hsct .dingwei .dingweib{
    left: 41.5%;
    top: 4%;
}
.hsct .dingwei .dingweic{
    left: 55.5%;
    top: 57%;
}
.hsct .dingwei .dingweid{
        left: 69%;
    top: 60.5%;
}
.hsctt .dingwei .dingweia{
    left: 88%;
    top: 52%;
}
.hsctt .dingwei .dingweib{
    left: 15%;
    top: 60%;
}
.hsctt .dingwei .dingweic{
    left: 53%;
    top: 43%;
}

.hsctt .dingwei .dingweid{
  left: 63%;
  top: 30%;
}

.hsctt .dingwei .dingweie{
  left: 78.5%;
  top: 56%;
}

.kitchenWap .dwzhankai ul{
    width: 875px;
    height: 710px;
}
.kitchenWap .dwzhankai ul li .cfimg{
    width: 400px;
    height: 352.5px;
    margin:88px 0 25px 355px;
}
.kitchenWap .dwzhankai ul li div{
    font-size: 30px;
    padding-top: 0;
}
.kitchenWap .dwzhankai ul li p{
    padding-top: 15px;
    font-size: 16px;
}
.hscttitle{
    font-size: 30px;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 60px;
}

/* 轻法式主套的+号位置 */
.lightFrench .dingwei .dingweia{
    left: 7%;
    top: 50%;
}
.lightFrench .dingwei .dingweic{
    left: 50%;
    top: 65%;
}
</style>
